<template>
  <div>
    <div class="card card-custom card-sticky" v-if="!mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer">
            <span class="label label-xl label-dot label-primary mr-2"></span> Turno 1 <i class="mr-2"></i>
            <small v-if="ui.estaCargandoDatos" class="">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{ auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="doCargarFicha()"><i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin ' : '']"></i></a>
        </div>
      </div>
    </div>
    <div class="card card-custom card-sticky" v-if="mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
            <span class="label label-xl label-dot label-primary mr-2"></span> Turno 1 <i class="mr-2"></i>
            <small class="">{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <span v-if="auth.puedeCambiarEstadoFinalizado == true">
            <a href="#" v-if="finalizado == true" class="btn btn-sm btn-light-danger font-weight-bold mr-2" v-b-tooltip.left title="Presione para desbloquear" @click.prevent="doToggleFinalizado()"> <i class="fa fa-lock"></i>Finalizado</a>
            <a href="#" v-if="finalizado == false" class="btn btn-sm btn-light font-weight-bold mr-2" v-b-tooltip.left title="Presione para bloquear" @click.prevent="doToggleFinalizado()"> <i class="fa fa-unlock-alt"></i>Desbloquear</a>
          </span>
          <span v-if="auth.puedeCambiarEstadoFinalizado == false">
            <a href="#" v-if="finalizado == true" class="btn btn-sm btn-light-danger font-weight-bold mr-2"> <i class="fa fa-lock"></i>Finalizado</a>
          </span>

          <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" @click.prevent="doGuardado()"><i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i> Guardar cambios</a>

          <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="$emit('update:expandirContenido', !expandirContenido)"><i class="fa p-0" :class="[expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i></a>
        </div>
      </div>
      <div class="card-body" v-show="expandirContenido">
        <form class="form" id="frm-turno-1">
          <div class="row">
            <div class="col-xl-2"></div>
            <div class="col-xl-8">

              <!-- I. Marcar con una aspa (X) la presencia de: -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">I. Seleccionar la presencia de:</h3>
                <div class="form-group row">
                  <label :class="ui.colLeftClass">Presencia de:</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group mb-2" role="group">
                      <button type="button" @click.prevent="actual.t1PresenciaOnpe = !actual.t1PresenciaOnpe" class="btn" :class="[actual.t1PresenciaOnpe ? 'btn-primary' : 'btn-outline-secondary']">ONPE</button>
                      <button type="button" @click.prevent="actual.t1PresenciaJne = !actual.t1PresenciaJne" class="btn" :class="[actual.t1PresenciaJne ? 'btn-primary' : 'btn-outline-secondary']">JNE</button>
                      <button type="button" @click.prevent="actual.t1PresenciaFfaapnp = !actual.t1PresenciaFfaapnp" class="btn" :class="[actual.t1PresenciaFfaapnp ? 'btn-primary' : 'btn-outline-secondary']">FFAA / PNP</button>
                      <button type="button" @click.prevent="actual.t1PresenciaMinisterioPublico = !actual.t1PresenciaMinisterioPublico" class="btn" :class="[actual.t1PresenciaMinisterioPublico ? 'btn-primary' : 'btn-outline-secondary']">Ministerio Público</button>
                      <button type="button" @click.prevent="actual.t1PresenciaDefensoriaDelPueblo = !actual.t1PresenciaDefensoriaDelPueblo" class="btn" :class="[actual.t1PresenciaDefensoriaDelPueblo ? 'btn-primary' : 'btn-outline-secondary']">Defensoría del Pueblo</button>
                    </div>
                    <div class="form-check mt-2">
                      <input class="form-check-input" type="checkbox" v-model="actual.t1PresenciaOtros" id="chkPresenciaOtros">
                      <label class="form-check-label" for="chkPresenciaOtros">Otros</label>
                    </div>
                    <textarea v-if="actual.t1PresenciaOtros" v-model="actual.t1PresenciaOtrosDetalle" class="form-control mt-2" type="text" placeholder="Indicar el nombre de la entidad..."></textarea>
                  </div>
                </div>
              </div>

              <!-- III. LOCAL DE VOTACIÓN -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">III. LOCAL DE VOTACIÓN</h3>

                <!-- 3.1 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.1. Número de mesas de votación instaladas:</label>
                  <div :class="ui.colRightClass">
                    <input type="text" class="form-control" v-model="actual.t1PorcentajeMesasInstaladas" placeholder="Ingrese el número de mesas instaladas..." />
                  </div>
                </div>

                <!-- 3.2 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.2. ¿Se observa material de campaña dentro del local de votación?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1SeObservaMaterialCampaniaDentroLocal = true" class="btn" :class="[actual.t1SeObservaMaterialCampaniaDentroLocal === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="limpiarMaterialCampaniaDentroLocal" class="btn" :class="[actual.t1SeObservaMaterialCampaniaDentroLocal === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t1SeObservaMaterialCampaniaDentroLocal === true" class="mt-2">
                      <label class="mb-1">Organización(es) política(s):</label>
                      <div class="card-body py-0">
                        <table class="table mb-0">
                          <tbody>
                            <template v-for="(item, index) in actual.itemsT1SeObservaMaterialCampaniaDentroLocal">
                              <tr :key="'mc-' + index">
                                <td>
                                  <img class="symbol-label" :src="getImagenPartidoPolitico(item.organizacionPoliticaParamId)" style="width:40px;height:auto;" />
                                </td>
                                <td class="w-75">
                                  <select class="form-control" v-model="item.organizacionPoliticaParamId">
                                    <option :value="null">- Seleccione organización -</option>
                                    <optgroup label="Partidos Políticos">
                                      <option v-for="partido in partidosNacionales" :key="'mc-pp-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                    </optgroup>
                                    <!-- <optgroup label="Movimientos Regionales">
                                      <option v-for="partido in partidosRegionales" :key="'mc-mr-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                    </optgroup> -->
                                  </select>
                                </td>
                                <td>
                                  <a href="#" class="btn btn-outline-secondary" @click.prevent="deleteItemPersoneroAltercados(actual.itemsT1SeObservaMaterialCampaniaDentroLocal, item)"><i class="fa fa-trash p-0 text-danger"></i></a>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                      <a href="#" class="btn btn-secondary btn-sm" @click.prevent="addItemPersoneroAltercados(actual.itemsT1SeObservaMaterialCampaniaDentroLocal)"><i class="fa fa-plus"></i> Agregar</a>
                      <textarea v-model="actual.t1SeObservaMaterialCampaniaDentroLocalDetalle" class="form-control mt-2" type="text" placeholder="Señale brevemente el detalle..."></textarea>
                    </div>
                  </div>
                </div>

                <!-- 3.3 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.3. ¿Observaste personas con elementos (ropa, gorros, pines, carteles o similares) a favor de alguna organización política dentro del local de votación?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1PersonasConElementosPropagandaDentroLocal = true" class="btn" :class="[actual.t1PersonasConElementosPropagandaDentroLocal === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1PersonasConElementosPropagandaDentroLocal = false" class="btn" :class="[actual.t1PersonasConElementosPropagandaDentroLocal === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t1PersonasConElementosPropagandaDentroLocal === true" class="mt-2">
                      <div class="card-body py-0">
                        <table class="table mb-0">
                          <tbody>
                            <template v-for="(item, index) in actual.itemsPersoneros">
                              <tr :key="index">
                                <td>
                                  <img class="symbol-label" :src="getImagenPartidoPolitico(item.organizacionPoliticaParamId)" style="width:40px;height:auto;" />
                                </td>
                                <td class="w-75">
                                  <select class="form-control" v-model="item.organizacionPoliticaParamId" required data-parsley-errors-container="#turno-1-msj-error-personer">
                                    <option :value="null">- seleccione partido -</option>
                                    <optgroup label="Partidos Políticos">
                                      <option v-for="partido in partidosNacionales" :key="partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                    </optgroup>
                                    <!-- <optgroup label="Movimientos Regionales">
                                      <option v-for="partido in partidosRegionales" :key="'mr-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                    </optgroup> -->
                                  </select>
                                  <input type="number" min="1" max="99" class="form-control mt-2 w-50" v-model="item.numero" placeholder="Cantidad..."/>
                                </td>
                                <td>
                                  <a href="#" class="btn btn-outline-secondary" @click.prevent="deleteItemPersonero(item)"><i class="fa fa-trash p-0 text-danger"></i></a>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                      <div>
                        <a href="#" class="btn btn-secondary " @click.prevent="addItemPersonero(actual.itemsPersoneros)"><i class="fa fa-plus"></i> Agregar</a>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 3.4 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.4. ¿El local de votación está debidamente señalizado?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1LocalDebidamenteSenializado = true" class="btn" :class="[actual.t1LocalDebidamenteSenializado === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1LocalDebidamenteSenializado = false" class="btn" :class="[actual.t1LocalDebidamenteSenializado === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t1LocalDebidamenteSenializado === false" v-model="actual.t1LocalDebidamenteSenializadoDetalle" class="form-control mt-2" type="text" placeholder="Señale brevemente por qué..."></textarea>
                  </div>
                </div>
              </div>

              <!-- IV. INCIDENCIAS -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">IV. INCIDENCIAS</h3>

                <!-- 4.1 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">4.1. ¿Se produjo alguna acción que impida tu labor como observador/a electoral?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1AccionImpideLaborObservador = true" class="btn" :class="[actual.t1AccionImpideLaborObservador === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1AccionImpideLaborObservador = false" class="btn" :class="[actual.t1AccionImpideLaborObservador === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t1AccionImpideLaborObservador === true" v-model="actual.t1AccionImpideLaborObservadorDetalle" class="form-control mt-2" type="text" placeholder="Señale brevemente el detalle..."></textarea>
                  </div>
                </div>

                <!-- 4.2 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">4.2. ¿Se reportó el abandono de miembros de mesa?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1ReporteAbandonoMiembrosMesaLocal = true" class="btn" :class="[actual.t1ReporteAbandonoMiembrosMesaLocal === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1ReporteAbandonoMiembrosMesaLocal = false" class="btn" :class="[actual.t1ReporteAbandonoMiembrosMesaLocal === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t1ReporteAbandonoMiembrosMesaLocal === true" class="mt-2">
                      <label class="mb-1">N.° de mesa:</label>
                      <input type="text" class="form-control mb-2" v-model="actual.t1ReporteAbandonoMiembrosMesaLocalNroMesa" placeholder="Número de mesa..." />
                      <textarea v-model="actual.t1ReporteAbandonoMiembrosMesaLocalDetalle" class="form-control" type="text" placeholder="Señale brevemente el detalle..."></textarea>
                    </div>
                  </div>
                </div>

                <!-- 4.3 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">4.3. ¿Se observaron altercados entre personeros de organizaciones políticas?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1AltercadosEntrePersoneros = true" class="btn" :class="[actual.t1AltercadosEntrePersoneros === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1AltercadosEntrePersoneros = false" class="btn" :class="[actual.t1AltercadosEntrePersoneros === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t1AltercadosEntrePersoneros === true" class="mt-2">
                      <label class="mb-1">Organizaciones políticas involucradas:</label>
                      <div class="card-body py-0">
                        <table class="table mb-0">
                          <tbody>
                            <template v-for="(item, index) in actual.itemsT1AltercadosEntrePersoneros">
                              <tr :key="index">
                                <td>
                                  <img class="symbol-label" :src="getImagenPartidoPolitico(item.organizacionPoliticaParamId)" style="width:40px;height:auto;" />
                                </td>
                                <td class="w-75">
                                  <select class="form-control" v-model="item.organizacionPoliticaParamId">
                                    <option :value="null">- Seleccione organización -</option>
                                    <optgroup label="Partidos Políticos">
                                      <option v-for="partido in partidosNacionales" :key="partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                    </optgroup>
                                    <!-- <optgroup label="Movimientos Regionales">
                                      <option v-for="partido in partidosRegionales" :key="'mra-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                    </optgroup> -->
                                  </select>
                                </td>
                                <td>
                                  <a href="#" class="btn btn-outline-secondary" @click.prevent="deleteItemPersoneroAltercados(actual.itemsT1AltercadosEntrePersoneros, item)"><i class="fa fa-trash p-0 text-danger"></i></a>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                      <a href="#" class="btn btn-secondary btn-sm" @click.prevent="addItemPersoneroAltercados(actual.itemsT1AltercadosEntrePersoneros)"><i class="fa fa-plus"></i> Agregar</a>
                      <textarea v-model="actual.t1AltercadosEntrePersonerosDetalle" class="form-control mt-2" type="text" placeholder="Señale brevemente el detalle..."></textarea>
                    </div>
                  </div>
                </div>

                <!-- 4.4 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">4.4. ¿Observaste algún otro incidente?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1OtroIncidenteLocal = true" class="btn" :class="[actual.t1OtroIncidenteLocal === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1OtroIncidenteLocal = false" class="btn" :class="[actual.t1OtroIncidenteLocal === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t1OtroIncidenteLocal === true" v-model="actual.t1OtroIncidenteLocalDetalle" class="form-control mt-2" type="text" placeholder="Señale brevemente el detalle..."></textarea>
                  </div>
                </div>
              </div>

              <!-- V. RONDA FINAL -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">V. RONDA FINAL</h3>

                <!-- 5.1 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">5.1. Antes de cerrar tu turno, ¿Cuántas mesas se llegaron a instalar en tu local de votación?</label>
                  <div :class="ui.colRightClass">
                    <input type="number" class="form-control" v-model="actual.t1CantidadMesasInstaladasCierreTurno" placeholder="Ingrese la cantidad..." min="0" />
                  </div>
                </div>

                <!-- Hora de cierre -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">Indique la hora en que se realizó el cierre de la ficha:</label>
                  <div :class="ui.colRightClass">
                    <input type="time" class="form-control" v-model="actual.t1HoraCierreTurno" />
                  </div>
                </div>
              </div>

            </div>
            <div class="col-xl-2"></div>

            <div v-if="eventosActualizacion.length > 0" v-html="eventosActualizacion"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.table-hover tbody tr:hover {
  background-color: #f9f9f9;
}
</style>

<script>
export default {
  name: "ficha-turno-1-local-2026",
  components: {},
  props: {
    localVotacionId: {
      type: Number,
    },
    procesoElectoralId: {
      type: Number,
    },
    expandirContenido: {
      type: Boolean,
    },
    intervaloAutoGuardado: {
      type: Number,
    },
  },
  data: () => ({
    finalizado: false,
    auth: {
      autorizadoEdicionTurno: null,
      mensajeNoAutorizadoEdicionTurno: null,
      puedeCambiarEstadoFinalizado: null,
      puedeEditarTurno: null,
      puedeVisualizarTurno: null,
      puedeFinalizarTurno: null,
      puedeReanudarTurno: null,
      fechaInicioTurno: null,
      fechaFinTurno: null,
      fechaInicioEdicionTurno: null,
      fechaFinEdicionTurno: null,
    },
    ui: {
      colLeftClass: "col-sm-12 col-md-5",
      colRightClass: "col-sm-12 col-md-7",
      estaGuardando: false,
      estaCargandoDatos: false,
      tieneCargaInicial: false,
    },
    temporizadorGuardado: null,
    eventosActualizacion: [],
    actual: {
      t1PresenciaOnpe: null,
      t1PresenciaJne: null,
      t1PresenciaFfaapnp: null,
      t1PresenciaMinisterioPublico: null,
      t1PresenciaDefensoriaDelPueblo: null,
      t1PresenciaOtros: null,
      t1PresenciaOtrosDetalle: null,
      t1PorcentajeMesasInstaladas: null,
      t1SeObservaMaterialCampaniaDentroLocal: null,
      t1SeObservaMaterialCampaniaDentroLocalDetalle: null,
      t1SeObservaMaterialCampaniaDentroLocalOrganizacionParamId: null,
      itemsT1SeObservaMaterialCampaniaDentroLocal: [],
      t1PersonasConElementosPropagandaDentroLocal: null,
      t1LocalDebidamenteSenializado: null,
      t1LocalDebidamenteSenializadoDetalle: null,
      t1AccionImpideLaborObservador: null,
      t1AccionImpideLaborObservadorDetalle: null,
      t1ReporteAbandonoMiembrosMesaLocal: null,
      t1ReporteAbandonoMiembrosMesaLocalDetalle: null,
      t1ReporteAbandonoMiembrosMesaLocalNroMesa: null,
      t1AltercadosEntrePersoneros: null,
      t1AltercadosEntrePersonerosDetalle: null,
      t1AltercadosEntrePersonerosOrganizacionParamId: null,
      itemsT1AltercadosEntrePersoneros: [],
      t1OtroIncidenteLocal: null,
      t1OtroIncidenteLocalDetalle: null,
      t1CantidadMesasInstaladasCierreTurno: null,
      t1HoraCierreTurno: null,
      itemsPersoneros: [],
    },
    guardado: {
      t1PresenciaOnpe: null,
      t1PresenciaJne: null,
      t1PresenciaFfaapnp: null,
      t1PresenciaMinisterioPublico: null,
      t1PresenciaDefensoriaDelPueblo: null,
      t1PresenciaOtros: null,
      t1PresenciaOtrosDetalle: null,
      t1PorcentajeMesasInstaladas: null,
      t1SeObservaMaterialCampaniaDentroLocal: null,
      t1SeObservaMaterialCampaniaDentroLocalDetalle: null,
      t1SeObservaMaterialCampaniaDentroLocalOrganizacionParamId: null,
      itemsT1SeObservaMaterialCampaniaDentroLocal: [],
      t1PersonasConElementosPropagandaDentroLocal: null,
      t1LocalDebidamenteSenializado: null,
      t1LocalDebidamenteSenializadoDetalle: null,
      t1AccionImpideLaborObservador: null,
      t1AccionImpideLaborObservadorDetalle: null,
      t1ReporteAbandonoMiembrosMesaLocal: null,
      t1ReporteAbandonoMiembrosMesaLocalDetalle: null,
      t1ReporteAbandonoMiembrosMesaLocalNroMesa: null,
      t1AltercadosEntrePersoneros: null,
      t1AltercadosEntrePersonerosDetalle: null,
      t1AltercadosEntrePersonerosOrganizacionParamId: null,
      itemsT1AltercadosEntrePersoneros: [],
      t1OtroIncidenteLocal: null,
      t1OtroIncidenteLocalDetalle: null,
      t1CantidadMesasInstaladasCierreTurno: null,
      t1HoraCierreTurno: null,
      itemsPersoneros: [],
    },

    partidos: [],
    tieneMovimientosRegionales: false,
  }),
  computed: {
    partidosNacionales: function() {
      return (this.partidos || []).filter(function(p) { return p.regionId == 0; });
    },
    partidosRegionales: function() {
      return (this.partidos || []).filter(function(p) { return p.regionId != 0; });
    },
    isDirty: function() {
      return JSON.stringify(this.actual) != JSON.stringify(this.guardado);
    },
    mostrarDetalleFicha: function() {
      if (!this.ui.tieneCargaInicial) return false;
      if (!this.auth.autorizadoEdicionTurno) return false;

      return true;
    },
  },
  methods: {
    fetchPartidosPoliticos: function() {
      this.$http
        .get(this.apiRoute("Parameter", "ListParametrosPoliticos"), {
          params: {
            Id: this.localVotacionId,
          },
        })
        .then(function(response) {
          var parameterResponse = response.body.data;
          this.partidos = parameterResponse;
        });
    },
    getImagenPartidoPolitico: function(partidoPoliticoParamId) {
      var partido = this.partidos.find((x) => x.parametroId == partidoPoliticoParamId);
      var imagen = partido ? partido.imagen : null;

      if (imagen == null) {
        imagen = "app-partidos/_no-image.png";
      }

      return `${this.apiResource(imagen)}`;
    },
    addItemPersonero: function(list) {
      list.push({
        localVotacionFichaPersoneroId: null,
        numero: 1,
        organizacionPoliticaParamId: null,
      });
    },
    deleteItemPersonero: async function(item) {
      if (await this.sweetConfirm("¿Confirma que se debe eliminar este elemento?")) {
        this.actual.itemsPersoneros = this.removeArrayItem(this.actual.itemsPersoneros, item);
      }
    },
    addItemPersoneroAltercados: function(arr) {
      if (!arr) return;
      arr.push({ organizacionPoliticaParamId: null, numero: 1 });
    },
    deleteItemPersoneroAltercados: function(arr, item) {
      if (!arr) return;
      var idx = arr.indexOf(item);
      if (idx >= 0) arr.splice(idx, 1);
    },
    limpiarMaterialCampaniaDentroLocal: function() {
      this.actual.t1SeObservaMaterialCampaniaDentroLocal = false;
      this.actual.itemsT1SeObservaMaterialCampaniaDentroLocal = [];
      this.actual.t1SeObservaMaterialCampaniaDentroLocalDetalle = null;
      this.actual.t1SeObservaMaterialCampaniaDentroLocalOrganizacionParamId = null;
    },
    inicializarGuardado: function() {
      if (!this.intervaloAutoGuardado || this.intervaloAutoGuardado <= 0) return;
      if (!this.ui.tieneCargaInicial || this.ui.estaCargandoDatos) return;
      if (!this.auth.autorizadoEdicionTurno) return;
      var vm = this;
      clearTimeout(this.temporizadorGuardado);
      this.temporizadorGuardado = setTimeout(function() {
        if (!vm.ui.estaCargandoDatos && !vm.ui.estaGuardando && vm.isDirty) {
          vm.doGuardado(true);
        }
      }, this.intervaloAutoGuardado);
    },
    doCargarFicha: async function() {
      this.ui.estaCargandoDatos = true;
      var model = {
        localVotacionId: this.localVotacionId,
        procesoElectoralId: this.procesoElectoralId,
      };

      await this.$http.post(this.apiRoute("Sheet", "GetFichaTurnoUno"), model).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var ficha = response.body.data.ficha;

          var tempActual = this.cloneObject(this.actual);
          var tempGuardado = this.cloneObject(this.guardado);

          tempActual.t1PresenciaOnpe = this.actualizarBaseDiferente("t1PresenciaOnpe", tempActual, tempGuardado, ficha);
          tempActual.t1PresenciaJne = this.actualizarBaseDiferente("t1PresenciaJne", tempActual, tempGuardado, ficha);
          tempActual.t1PresenciaFfaapnp = this.actualizarBaseDiferente("t1PresenciaFfaapnp", tempActual, tempGuardado, ficha);
          tempActual.t1PresenciaMinisterioPublico = this.actualizarBaseDiferente("t1PresenciaMinisterioPublico", tempActual, tempGuardado, ficha);
          tempActual.t1PresenciaDefensoriaDelPueblo = this.actualizarBaseDiferente("t1PresenciaDefensoriaDelPueblo", tempActual, tempGuardado, ficha);
          tempActual.t1PresenciaOtros = this.actualizarBaseDiferente("t1PresenciaOtros", tempActual, tempGuardado, ficha);
          tempActual.t1PresenciaOtrosDetalle = this.actualizarBaseDiferente("t1PresenciaOtrosDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1PorcentajeMesasInstaladas = this.actualizarBaseDiferente("t1PorcentajeMesasInstaladas", tempActual, tempGuardado, ficha);
          tempActual.t1SeObservaMaterialCampaniaDentroLocal = this.actualizarBaseDiferente("t1SeObservaMaterialCampaniaDentroLocal", tempActual, tempGuardado, ficha);
          tempActual.t1SeObservaMaterialCampaniaDentroLocalDetalle = this.actualizarBaseDiferente("t1SeObservaMaterialCampaniaDentroLocalDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1SeObservaMaterialCampaniaDentroLocalOrganizacionParamId = this.actualizarBaseDiferente("t1SeObservaMaterialCampaniaDentroLocalOrganizacionParamId", tempActual, tempGuardado, ficha);
          tempActual.itemsT1SeObservaMaterialCampaniaDentroLocal = this.actualizarBaseDiferente("itemsT1SeObservaMaterialCampaniaDentroLocal", tempActual, tempGuardado, ficha);
          if (!tempActual.itemsT1SeObservaMaterialCampaniaDentroLocal || !Array.isArray(tempActual.itemsT1SeObservaMaterialCampaniaDentroLocal)) tempActual.itemsT1SeObservaMaterialCampaniaDentroLocal = [];
          tempActual.t1PersonasConElementosPropagandaDentroLocal = this.actualizarBaseDiferente("t1PersonasConElementosPropagandaDentroLocal", tempActual, tempGuardado, ficha);
          tempActual.t1LocalDebidamenteSenializado = this.actualizarBaseDiferente("t1LocalDebidamenteSenializado", tempActual, tempGuardado, ficha);
          tempActual.t1LocalDebidamenteSenializadoDetalle = this.actualizarBaseDiferente("t1LocalDebidamenteSenializadoDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1AccionImpideLaborObservador = this.actualizarBaseDiferente("t1AccionImpideLaborObservador", tempActual, tempGuardado, ficha);
          tempActual.t1AccionImpideLaborObservadorDetalle = this.actualizarBaseDiferente("t1AccionImpideLaborObservadorDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1ReporteAbandonoMiembrosMesaLocal = this.actualizarBaseDiferente("t1ReporteAbandonoMiembrosMesaLocal", tempActual, tempGuardado, ficha);
          tempActual.t1ReporteAbandonoMiembrosMesaLocalDetalle = this.actualizarBaseDiferente("t1ReporteAbandonoMiembrosMesaLocalDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1ReporteAbandonoMiembrosMesaLocalNroMesa = this.actualizarBaseDiferente("t1ReporteAbandonoMiembrosMesaLocalNroMesa", tempActual, tempGuardado, ficha);
          tempActual.t1AltercadosEntrePersoneros = this.actualizarBaseDiferente("t1AltercadosEntrePersoneros", tempActual, tempGuardado, ficha);
          tempActual.t1AltercadosEntrePersonerosDetalle = this.actualizarBaseDiferente("t1AltercadosEntrePersonerosDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1AltercadosEntrePersonerosOrganizacionParamId = this.actualizarBaseDiferente("t1AltercadosEntrePersonerosOrganizacionParamId", tempActual, tempGuardado, ficha);
          tempActual.itemsT1AltercadosEntrePersoneros = this.actualizarBaseDiferente("itemsT1AltercadosEntrePersoneros", tempActual, tempGuardado, ficha);
          if (!tempActual.itemsT1AltercadosEntrePersoneros || !Array.isArray(tempActual.itemsT1AltercadosEntrePersoneros)) tempActual.itemsT1AltercadosEntrePersoneros = [];
          tempActual.t1OtroIncidenteLocal = this.actualizarBaseDiferente("t1OtroIncidenteLocal", tempActual, tempGuardado, ficha);
          tempActual.t1OtroIncidenteLocalDetalle = this.actualizarBaseDiferente("t1OtroIncidenteLocalDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1CantidadMesasInstaladasCierreTurno = this.actualizarBaseDiferente("t1CantidadMesasInstaladasCierreTurno", tempActual, tempGuardado, ficha);
          tempActual.t1HoraCierreTurno = this.actualizarBaseDiferente("t1HoraCierreTurno", tempActual, tempGuardado, ficha);
          tempActual.itemsPersoneros = this.actualizarBaseDiferente("itemsPersoneros", tempActual, tempGuardado, ficha);

          this.actual = this.cloneObject(tempActual);
          // Misma forma que `actual`: `ficha` del API no trae todas las claves del formulario y isDirty quedaría siempre en true
          this.guardado = this.cloneObject(this.actual);
          this.auth = response.body.data.auth;
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
    },
    actualizarBaseDiferente: function(propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      var valorActual = JSON.stringify(fichaActual[propiedad]);
      var valorGuardado = JSON.stringify(fichaGuardado[propiedad]);
      var valorActualizado = JSON.stringify(fichaActualizada[propiedad]);

      if (valorActual == valorGuardado && valorGuardado != valorActualizado) {
        return fichaActualizada[propiedad];
      } else {
        return fichaActual[propiedad];
      }
    },
    doGuardado: async function(omitirNotificacion) {
      if (this.ui.estaGuardando) return;

      if (!this.isFormValid("frm-turno-1")) {
        if (omitirNotificacion != true) {
          this.$bvToast.toast("Hay campos con valores incorrectos. Revise los datos ingresados.", {
            title: "Turno 1",
            autoHideDelay: 5000,
            variant: "warning",
            appendToast: false,
            solid: true,
          });
        }
        return false;
      }

      var actualClone = this.cloneObject(this.actual);
      var model = this.cloneObject(this.actual);
      model.localVotacionId = this.localVotacionId;
      model.procesoElectoralId = this.procesoElectoralId;

      var guardadoExistoso = false;
      this.ui.estaGuardando = true;
      await this.$http.post(this.apiRoute("Sheet", "EditFichaTurnoUno"), model).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.guardado = actualClone;

          if (omitirNotificacion != true) {
            this.$bvToast.toast("Los cambios se han guardado correctamente.", {
              title: "Turno 1",
              autoHideDelay: 5000,
              variant: "success",
              appendToast: false,
              solid: true,
            });
          }
          guardadoExistoso = true;

          this.doCargarFicha();

          this.$notifyHub.notificarCambioFicha(this.procesoElectoralId, this.localVotacionId, 1);
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.estaGuardando = false;
      return guardadoExistoso;
    },
    doToggleFinalizado: async function() {
      if (this.finalizado) {
        if (!(await this.sweetConfirm("¿Desea desbloquear esta sección?"))) {
          return;
        }
        this.finalizado = !this.finalizado;
      } else {
        if (!(await this.sweetConfirm("¿Desea finalizar esta sección?"))) {
          return;
        }
        this.finalizado = !this.finalizado;
      }
    },
  },
  watch: {
    isDirty: function(newValue) {
      if (newValue && this.intervaloAutoGuardado && this.intervaloAutoGuardado > 0) {
        this.inicializarGuardado();
      } else {
        clearTimeout(this.temporizadorGuardado);
      }
    },
    actual: {
      deep: true,
      handler() {
        if (this.intervaloAutoGuardado && this.intervaloAutoGuardado > 0 && this.ui.tieneCargaInicial && !this.ui.estaCargandoDatos && this.auth.autorizadoEdicionTurno) {
          this.inicializarGuardado();
        }
      },
    },
  },
  mounted: function() {
    this.initParsley();
    this.fetchPartidosPoliticos();
    this.doCargarFicha();
  },
  beforeDestroy: function() {
    clearTimeout(this.temporizadorGuardado);
  },
};
</script>
